import BillingInfoIcon from "public/cyber-security/edrmdrxdr/stash_billing-info.svg";
import SupportIcon from "public/cyber-security/edrmdrxdr/material-symbols_support.svg";
import RefreshIcon from "public/cyber-security/edrmdrxdr/charm_refresh.svg";
import ComplianceIcon from "public/cyber-security/edrmdrxdr/grommet-icons_compliance.svg";
import CubeImg from "public/cyber-security/edrmdrxdr/bxs_cube.svg";
import AnalyticsIcon from "public/cyber-security/edrmdrxdr/mdi_google-analytics.svg";

export const WHY_ONEMIND_CONSTANTS = {
  TITLE: "Why Security Teams Choose OneMind ",
  ITEMS: [
    {
      image: AnalyticsIcon,
      title: "Real-Time Detection",
      content:
        "AI-powered detection to eliminate blind spots and catch threats in motion.",
    },
    {
      image: CubeImg,
      title: "AI-Driven Prioritization",
      content: "Reduce false positives and alert fatigue, so SOC teams stay focused.",
    },
    {
      image: ComplianceIcon,
      title: "Cyber Insurance Ready",
      content: "Meet compliance requirements and strengthen your risk posture.",
    },
    {
      image: RefreshIcon,
      title: "30–45 Min MTTR",
      content: "Slash response time with automated workflows and expert-backed triage.",
    },

    {
      image: SupportIcon,
      title: "24/7 SOC Without the Overhead",
      content: "Get enterprise-grade protection—without building your own team.",
    },
    {
      image: BillingInfoIcon,
      title: "Zero-Day & Ransomware Defense",
      content: "Detect and neutralize advanced attacks before they execute.",
    },
  ],
};
